export default {
    selector: '.f-testimonials-slider',
    args: {
        prevNextButtons: false,
        contain: true,
        wrapAround: false,
        autoplay: true,
        pageDots: true,
        cellAlign: 'center',
        imagesLoaded: true,
        draggable: false
    }
}